import { RARITIES_ARR } from '../../constants/constants'
import HeroSummary from '../HeroCard/HeroSummary'
import './styles.css'

const SimpleHeroCard = ({ className, hero }) => {
    let classNames = `hero-summary ${RARITIES_ARR[hero.rarity]}`
    if (className) classNames += ` ${className}`

    return (
        <div className={classNames}>
            <HeroSummary hero={hero} />
        </div>
    )
}

export default SimpleHeroCard
